var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',{attrs:{"cols":"12","sm":"12","md":"3"}},[_c('v-btn',{staticClass:"px-2",attrs:{"dark":"","rounded":"","large":"","block":"","to":{ name: 'AnnualDeclaration' },"color":"info"}},[_vm._v(" informe de rendimentos "+_vm._s(_vm._f("moment")(_vm.$moment().subtract(1, 'years'),'YYYY'))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }